import { AxiosResponse } from "axios";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { HttpError } from "../../../../common/components/shared/httpError/httpError";
import Loader from "../../../../common/components/shared/loader/loader";
import { HttpErrorModel } from "../../../../common/models/httpError";
import { RouteParamsModel } from "../../../../common/models/routeParams";
import { Api } from "../../../../helpers/api";
import i18n from "../../../../i18n/i18n";
import { LocationEntryModel } from "../../../models/location";
import { LocationService } from "../../../services/locationService";
import LocationForm from "../locationForm/locationForm";

interface ModifyLocationState {
    locationData?: LocationEntryModel | null;
    response: AxiosResponse<HttpErrorModel[] | any> | undefined;
}

class ModifyLocation extends React.Component <RouteComponentProps, ModifyLocationState> {
    constructor(props: any) {
        super(props);

        this.state = {
            locationData: null,
            response: undefined
        };
    }

    private get locationData() {
        return this.state.locationData;
    }

    async componentDidMount() {
        const params = this.props.match.params as RouteParamsModel;
        const response = await LocationService.getLocation(params.id);

        this.setState({response});

        if (Api.isSuccess(response)) {
            this.setState({
                locationData: response?.data || null
            });
        }
    }

    render() {
        return (
            <div className="modify-location modify-record">
                <div className="content">
                    <div className="header">
                        {i18n.t("topology.locations.actions.modifyLocation.header")}
                    </div>
                    {this.renderContent()}
                </div>
            </div>
        );
    }

    protected renderContent() {
        if (!Api.isSuccess(this.state.response)) {
            return <HttpError
                response={this.state.response}
                cause={i18n.t("topology.locations.errors.selectedLocationErrorSuffix")}
            />;
        } else if (this.locationData) {
            return <LocationForm isUpdate={true} locationData={this.locationData}/>;
        } else {
            return (
                <Loader/>
            );
        }
    }
}

export default withRouter(ModifyLocation);